export default __webpack_public_path__ + "media/images/logos/logo_grey_2-340a7117301f071a40dbfe79e95a0410.svg";